import ReactSlider from "react-slider";
import styled, { css } from "styled-components";
import getBorderColor from "../../../utils/getBorderColor";
import getColor from "../../../utils/getColor";
import space from "../../../utils/space";
import unit from "../../../utils/unit";
var thumbHeightSpace = 3;
var dotHeightSpace = 1;
export var StyledSliderBar = styled(ReactSlider).withConfig({
  componentId: "sc-vu4mff-0"
})(["width:100%;height:", ";"], space(thumbHeightSpace));
export var StyledSliderBarThumb = styled.div.withConfig({
  componentId: "sc-vu4mff-1"
})(function (_ref) {
  var theme = _ref.theme;
  return css(["position:relative;height:", ";width:", ";background-color:", ";border-radius:50%;cursor:grab;"], space(thumbHeightSpace), space(thumbHeightSpace), getColor(theme, "white"));
});
export var StyledSliderBarDot = styled.div.withConfig({
  componentId: "sc-vu4mff-2"
})(function (_ref2) {
  var theme = _ref2.theme;
  return css(["position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);height:", ";width:", ";background-color:", ";border-radius:50%;"], space(dotHeightSpace), space(dotHeightSpace), getColor(theme, "primary"));
});
export var StyledSliderBarTrack = styled.div.withConfig({
  componentId: "sc-vu4mff-3"
})(function (_ref3) {
  var $index = _ref3.$index,
    $isRange = _ref3.$isRange,
    theme = _ref3.theme;
  return css(["top:", ";bottom:0;border-radius:", ";height:", ";", ""], space((thumbHeightSpace - dotHeightSpace) / 2), unit(100), space(dotHeightSpace), $isRange ? css(["background:", ";"], $index === 1 ? getColor(theme, "primary") : getBorderColor(theme, "backgroundLight", "extraLow")) : css(["background:", ";"], $index === 1 ? getBorderColor(theme, "backgroundLight", "extraLow") : getColor(theme, "primary")));
});